import { ChartEditorComponent } from "./chart-editor";
import { CourseInfoComponent } from "./course-info";
import { HomeComponent } from "./home";
import { LoginComponent } from "./login";
import { SchoolChartComponent } from "./school-chart";
import { SchoolsComponent } from "./schools";
import { ZoomLevelComponent } from "./zoom-level";

export * from "./chart-editor";
export * from "./course-info";
export * from "./home";
export * from "./login";
export * from "./school-chart";
export * from "./schools";
export * from "./zoom-level";

export const COMPONENTS = [
  SchoolsComponent,
  SchoolChartComponent,
  ZoomLevelComponent,
  LoginComponent,
  HomeComponent,
  ChartEditorComponent,
  CourseInfoComponent
];
